import AsyncStorage from '@react-native-async-storage/async-storage';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

export type ThemeMode = 'light' | 'dark';
type ThemePreference = ThemeMode | 'system';

interface ThemeStoreStateItems {
  theme: ThemePreference;
  realTheme: ThemeMode;
  widgetTheme: ThemeMode;
}

interface ThemeStoreState extends ThemeStoreStateItems {
  setTheme(theme: ThemeStoreState['theme']): void;
  setRealTheme(theme: ThemeStoreState['realTheme']): void;
  setWidgetTheme(theme: ThemeStoreState['widgetTheme']): void;
}

const initialState = {
  theme: 'system',
  realTheme: 'dark',
  widgetTheme: 'dark',
} satisfies ThemeStoreStateItems;

const useThemeStore = createWithEqualityFn<ThemeStoreState>()(
  persist(
    (set) => ({
      ...initialState,
      setTheme: (theme) => set(() => ({ theme })),
      setRealTheme: (theme) => set(() => ({ realTheme: theme })),
      setWidgetTheme: (theme) => set(() => ({ widgetTheme: theme })),
    }),
    {
      name: 'themeStore',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({
        theme: state.theme,
        realTheme: state.realTheme,
      }),
    },
  ),
);

export default useThemeStore;
